
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import CaseStudies from "./pages/CaseStudies";
import ProductExample from "./pages/ProductExample";
import Presentation from "./pages/Presentation";
import DemoRequest from "./pages/DemoRequest";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/about" element={<About />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/product-example" element={<ProductExample />} />
        <Route path="/presentation" element={<Presentation />} />
        <Route path="/demo-request" element={<DemoRequest />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
